<template>
  <Layout>
    <template v-slot:navigation>
      <topNav />
    </template>
    <template v-slot:content>
      <div
        class="custom-container-fluid"
        style="height: 300px; background-size: cover; background-repeat: no-repeat;"
        :style="{
          'background-image':
            'url(' + getCoverImage((team_details || {}).cover_page) + ')'
        }"
      ></div>
      <div class="container">
        <div class="row">
          <div class="col-sm-4">
            <div class="card">
              <div class="image text-center" style="margin-top:-70px">
                <img
                  :src="
                    team_details['team_logo']
                      ? team_details['team_logo']
                      : '../../../assets/images/juicy.png'
                  "
                  class="card-img-top img-fluid"
                  style="width: 231px; height: 194px; border-radius: 20px; z-index: 2222"
                  alt=""
                />
              </div>
              <div class="card-body" v-if="team_details['id']">
                <div class="row">
                  <div class="col-md-12">
                    <h3>{{ team_details["team_name"] }}</h3>
                  </div>
                </div>
                <div class="mb-2">
                  <span class="h5">Sector : </span>
                  <span class="h5 text-orange">{{
                    team_details["sector"]
                  }}</span>
                </div>
                <div class="mb-2">
                  <span class="h5">Year founded : </span>
                  <span class="h5 text-orange">{{
                    team_details["year_founded"]
                  }}</span>
                </div>
                <div class="mb-2">{{ team_details["team_phone"] }}</div>
                <div class="mb-2">{{ team_details["team_email"] }}</div>
                <!--                <div class="mb-2">www.google.com</div>-->
                <hr />
                <i class="fa fa-search" />
                <i class="fa fa-search" />
              </div>
              <div class="card-body" v-else>
                <div class="lines shine" v-for="(a, i) in 7" :key="i" />
              </div>
            </div>
          </div>
          <div class="col-sm-8">
            <div class="row mt-4">
              <div class="col-md-4">
                <button
                  @click="
                    $router.push(
                      '/invest-startup/' +
                        team_details['team_name'] +
                        '/' +
                        team_details['id']
                    ,() => {})
                  "
                  :disabled="!team_details['id']"
                  class="btn btn-orange"
                >
                  Invest in startup
                </button>
              </div>
              <div class="col-md-4">
                <button
                  @click="
                    $router.push(
                      '/partner-startup/' +
                        team_details['team_name'] +
                        '/' +
                        team_details['id'],() => {}
                    )
                  "
                  :disabled="!team_details['id']"
                  class="btn btn-green"
                >
                  Partner with startup
                </button>
              </div>
              <div class="col-md-4">
                <button
                  @click="
                    $router.push(
                      '/get-hired/' +
                        team_details['team_name'] +
                        '/' +
                        team_details['id'],() => {}
                    )
                  "
                  :disabled="!team_details['id']"
                  class="btn btn-outline-orange"
                >
                  Get hired by startup
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-body">
                    <h4 class="text-green">Pitch</h4>
                    <p v-if="team_details['id']">
                      {{ team_details["team_description"] }}
                    </p>
                    <div v-else>
                      <div class="lines shine" v-for="(a, i) in 2" :key="i" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h4 class="text-green">Founders</h4>
                <div class="row">
                  <div
                    class="col-md-6"
                    v-for="(item, i) in team_details['members']"
                    :key="i"
                  >
                    <div class="card">
                      <div class=" founder">
                        <img
                          v-lazy="
                            (item || {}).profile_pic
                              ? (item || {}).profile_pic
                              : '../assets/img-test/woman.jpg'
                          "
                          class="card-img-top img-fluid"
                          style="object-fit:cover; max-height: 300px;"
                          :alt="item.name"
                        />
                      </div>
                      <div class="card-body">
                        <p class="card-title text-center name">
                          {{ item.name }}
                        </p>
                        <div class="card-text text-center">
                          <div class="text-orange">{{ item.role }}</div>
                          <div>
                            <a
                              style="color: #395185;"
                              :href="
                                ((item || {}).media_handles || {}).facebook
                              "
                              v-if="((item || {}).media_handles || {}).facebook"
                            >
                              <i class="fab fa-facebook-square mr-3 fa-2x"
                            /></a>
                            <a
                              :href="((item || {}).media_handles || {}).twitter"
                              v-if="((item || {}).media_handles || {}).twitter"
                              ><i
                                class="fab fa-twitter-square mr-3 text-info fa-2x"
                            /></a>
                            <a
                              :href="
                                ((item || {}).media_handles || {}).whatsapp
                              "
                              v-if="((item || {}).media_handles || {}).whatsapp"
                              ><i
                                class="fab fa-whatsapp-square mr-3 text-success fa-2x"
                            /></a>
                            <a
                              :href="
                                ((item || {}).media_handles || {}).linkedin
                              "
                              v-if="((item || {}).media_handles || {}).linkedin"
                              ><i
                                class="fab fa-linkedin mr-3 text-primary fa-2x"
                            /></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="row"
                  v-if="(team_details['members'] || []).length < 1"
                >
                  <div class="col-md-12">
                    No Team Formed at the moment
                  </div>
                </div>
              </div>
            </div>
            <div class="card" v-if="team_details['video_url']">
              <div class="card-body">
                <h4 class="text-green">Pitch video</h4>
                <div class="embed-responsive embed-responsive-16by9 mb-5">
                  <video
                    :src="team_details['video_url']"
                    style="border-radius: 20px; width: 100%"
                    controls="true"
                    loop
                    class="embed-responsive-item"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Layout>
</template>

<script>
import layout from "@/components/app-layout";
import navigation from "@/components/topNav";
import axios from "axios";

export default {
  components: {
    Layout: layout,
    topNav: navigation
  },
  data: () => {
    return {
      team: [],
      team_details: {}
    };
  },
  methods: {
    getCoverImage(image) {
      if (image && image !== "null") {
        return image;
      } else return "/../assets/images/profile_back.png";
    },

    getStartupProfile() {
      this.isLoading = true;
      axios
        .get(
          `${process.env.VUE_APP_ENDPOINT_BASE_URL}/startup/${this.$route.params.team_id}/program/${this.$route.params.program_id}`
        )
        .then(res => {
          this.team_details = res.data.data;
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  created() {
    document.body.style.background = "#F3F7FF";
    this.getStartupProfile();
  },
  mounted() {}
};
</script>

<style scoped>
.btn {
  border-radius: 10px;
}
@media screen and (max-width: 600px) {
}
</style>
